// Two-sided cards (Druid avatar etc.) reuse the existing face-down
// mesh rotation but the geometric back carries the alternate printed
// face. Keep `card.face` in lock step with `card.faceDown` so the
// inspector seeds from the on-table face when the player opens it.
// No-op for normal cards (where `face` is meaningless).
export function syncCardFace(card) {
  if (!card?.backFaceImagePath && !card?.backFaceImageUrl) return;
  card.face = card.faceDown ? 'back' : 'front';
}
